import { defineStore } from "pinia";
import Network from "~/utils/network";
import { useRoute } from "vue-router";

const urls = {
  getReviewQuestions: (publicId) =>
    `/administration/review/configs-public/${publicId}`,
  create: (publicId) => `/customer/review/create/${publicId}`,
  getSummary: `/customer/review/summary`,
  getBestSellingProducts: (financier) =>
    `/customer/review/best-selling/${financier}`,
  getFeaturedReviews: (countryId) => `/customer/review/featured/${countryId}`,
  getReviewById: (id) => `/customer/review/${id}`,
};

export const useReviewStore = defineStore("review", {
  state: () => ({
    reviewQuestions: {},
    reviewSummary: {},
    bestSellingProducts: [],
    featuredReviews: [],
    review: {},
  }),
  actions: {
    fetchReviewQuestions: async function (publicId) {
      try {
        const { list } = await Network.http(urls.getReviewQuestions(publicId), {
          method: "GET",
        });
        this.reviewQuestions = list.sort((a, b) => a.rowIndex - b.rowIndex);
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    fetchReviewSummary: async function () {
      try {
        this.reviewSummary = await Network.http(urls.getSummary, {
          method: "GET",
        });
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    fetchReviewById: async function (id) {
      try {
        this.review = await Network.http(urls.getReviewById(id), {
          method: "GET",
        });
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    createReview: async function ({ publicId, review }) {
      try {
        await Network.http(urls.create(publicId), {
          method: "POST",
          body: review,
        });
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    fetchBestSellingProducts: async function (financer) {
      try {
        this.bestSellingProducts = await Network.http(
          urls.getBestSellingProducts(financer),
          { method: "GET" }
        );
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    fetchFeaturedReviews: async function (countryId) {
      try {
        this.featuredReviews = await Network.http(urls.getFeaturedReviews(countryId), {
          method: "GET",
        });
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
  },
  getters: {},
});
